<template>
    <div>
        <h1 class="display-heading">{{ pageTitle }}</h1>
        <button class="btn btn-primary btn-primary-insv mb-3" @click="download">Download {{ documentName }}</button>
        <pdf style="border: 1px solid #ccc;" class="mb-3" :src="pdfUrl"
            :page="currentPage"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event">
        </pdf>
        <p class="text-center">
            Currently viewing page {{currentPage}} of {{pageCount}}
        </p>
        <div class="d-flex justify-content-center">
            <button v-if="currentPage > 1" class="mr-3 btn btn-secondary btn-primary-insv" @click="currentPage-=1">
                Previous Page
            </button>

            <button v-if="pageCount > 1 && currentPage<pageCount" class="btn btn-primary btn-primary-insv" @click="currentPage+=1">
                Next Page
            </button>
        </div>
    </div>
</template>

<script>
import pdf from 'vue-pdf';
export default {
    'name': 'PaymentDocumentViewer',
    'components': {
        pdf
    },
    'computed': {
        documentId () {
            return this.$route.params.id;
        },
        pageTitle () {
            switch (this.$route.name) {
            case 'view-payment-receipt':return 'View Payment Receipt';
            case 'view-payment-slip':return 'View Payment Slip';
            case 'view-invoice':return 'View Invoice';
            default: return 'View PDF';
            }
        },
        apiUrl () {
            switch (this.$route.name) {
            case 'view-payment-receipt':return 'PaymentReceipt/Download';
            case 'view-payment-slip':return 'PaymentSlip/Download';
            case 'view-invoice':return 'Invoice/Download';
            default: return '';
            }
        },
        documentName () {
            switch (this.$route.name) {
            case 'view-payment-receipt':return 'Payment Receipt';
            case 'view-payment-slip':return 'Payment Slip';
            case 'view-invoice':return 'Invoice';
            default: return 'Document';
            }
        }
    },
    data () {
        return {
            'pdfUrl': '',
            'currentPage': 1,
            'pageCount': 0
        };
    },
    mounted () {
        this.getPdfUrl();
    },
    'methods': {
        getPdfUrl (callback) {
            if (this.apiUrl) {
                this.axios.get(this.apiUrl, {
                    'params': {
                        'id': this.documentId
                    }
                }).then(({ data }) => {
                    if (data.data) {
                        this.pdfUrl = data.data;

                        if (typeof callback === 'function') {
                            callback(data.data);
                        }
                    }
                });
            }
        },
        download () {
            this.getPdfUrl((url) => {
                window.open(url);
            });
        }

    }
};
</script>
